import './button.css'
import filter from './img/filter.svg'
import dowload from './img/File download.svg'
import dowload2 from './img/Icons.svg'

export const Button = (props) => {
    return (
        <button style={{ cursor: props.disabled ? 'not-allowed' : '', background: props.disabled ? '#BDBDBD' : '', border: props.disabled ? 'none' : '', ...props.style }} className={`button-component ${props.className}`} disabled={props.disabled} type={props.typeButton} onClick={props.onClick}>
            <img style={props.icon || props.type ? { display: 'flex' } : { display: 'none' }} src={props.icon ? props.icon : props.type === 'filter' ? filter : props.type === 'download' ? dowload : props.type === 'downloadBlack' ? dowload2 : props.icon} alt='icon button' />
            <span>{props.label ? props.label : props.type === 'filter' ? 'Filter' : props.type === 'download' ? 'Export Data' : props.type === 'downloadBlack' ? 'Export Data' : props.label}</span>
            {
                props.children
            }
        </button>
    )
}